import { render } from "./FormularioProduto.vue?vue&type=template&id=badba7e2&scoped=true"
import script from "./FormularioProduto.vue?vue&type=script&lang=js"
export * from "./FormularioProduto.vue?vue&type=script&lang=js"

import "./FormularioProduto.vue?vue&type=style&index=0&id=badba7e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badba7e2"]])

export default __exports__